import React, { useState } from 'react';
import './WelcomeModal.css';

const PANELS = [
  {
    eyebrow: 'WELCOME, OPERATIVE',
    title: 'Your lectures become your game.',
    body: 'Upload PowerPoints and master your material through boss fights, drug card drills, and adaptive practice.',
  },
  {
    eyebrow: 'YOUR ARSENAL',
    title: 'Build your route to mastery.',
    blocks: [
      {
        icon: 'upload',
        label: 'Upload',
        body: 'Turn slide decks into structured study content.',
      },
      {
        icon: 'map',
        label: 'Study Map',
        body: 'Follow topics, objectives, dialysis nodes, and bosses.',
      },
      {
        icon: 'crown',
        label: 'Master',
        body: 'Earn XP, currency, and stronger recall over time.',
      },
    ],
  },
  {
    eyebrow: 'START EXPLORING',
    title: 'Discovery is part of training.',
    body: 'Glowing elements around the interface teach you features and reward currency + XP. Discover all 13 to complete your training.',
  },
];

function PanelIcon({ name }) {
  if (name === 'upload') {
    return (
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <path d="M12 16V5" />
        <path d="M8 9l4-4 4 4" />
        <path d="M5 19h14" />
      </svg>
    );
  }

  if (name === 'map') {
    return (
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <path d="M4 6.5 9 4l6 2 5-2v13.5L15 20l-6-2-5 2z" />
        <path d="M9 4v14" />
        <path d="M15 6v14" />
      </svg>
    );
  }

  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path d="m12 4 2.2 4.5L19 10l-3.5 3.4.8 4.8L12 16l-4.3 2.2.8-4.8L5 10l4.8-1.5z" />
    </svg>
  );
}

export default function WelcomeModal({ onDismiss }) {
  const [panelIndex, setPanelIndex] = useState(0);
  const isLast = panelIndex === PANELS.length - 1;

  return (
    <div className="welcome-overlay">
      <div className="welcome-modal" role="dialog" aria-modal="true" aria-labelledby={`welcome-title-${panelIndex}`}>
        <div className="welcome-accent" />
        <div className="welcome-panels">
          <div
            className="welcome-panels-track"
            style={{ transform: `translateX(-${panelIndex * 100}%)` }}
          >
            {PANELS.map((panel, index) => (
              <section key={panel.eyebrow} className="welcome-panel">
                <div className="welcome-mark">
                  <span className="welcome-mark-ring" />
                  <img src="/favicon-32x32.png?v=7" alt="" className="welcome-mark-icon" />
                </div>
                <span className="welcome-eyebrow">{panel.eyebrow}</span>
                <h2 id={`welcome-title-${index}`} className="welcome-title">{panel.title}</h2>
                {panel.blocks ? (
                  <div className="welcome-arsenal">
                    {panel.blocks.map((block) => (
                      <div key={block.label} className="welcome-arsenal-block">
                        <div className="welcome-arsenal-icon">
                          <PanelIcon name={block.icon} />
                        </div>
                        <div className="welcome-arsenal-label">{block.label}</div>
                        <div className="welcome-arsenal-body">{block.body}</div>
                      </div>
                    ))}
                  </div>
                ) : (
                  <p className="welcome-body">{panel.body}</p>
                )}
              </section>
            ))}
          </div>
        </div>

        <div className="welcome-footer">
          <div className="welcome-dots" aria-hidden="true">
            {PANELS.map((panel, index) => (
              <span
                key={panel.eyebrow}
                className={`welcome-dot${index === panelIndex ? ' welcome-dot--active' : ''}`}
              />
            ))}
          </div>
          <button
            className="welcome-btn"
            onClick={() => {
              if (isLast) {
                onDismiss();
              } else {
                setPanelIndex(panelIndex + 1);
              }
            }}
          >
            {isLast ? 'Begin' : 'Next'}
          </button>
        </div>
      </div>
    </div>
  );
}
